import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { LiveBadge } from "../components/Layout";
import { Users } from "lucide-react";

export default function LiveFeedPage() {
  const [streams, setStreams] = useState([]);
  useEffect(() => {
    api.get("/streams?live_only=true").then(({data}) => setStreams(data));
  }, []);
  return (
    <div className="pb-24 md:pb-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
      <h1 className="font-display font-black text-4xl sm:text-6xl uppercase mb-6">Live<span className="text-[#FF007F]">.</span> right now.</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {streams.map(s => (
          <Link key={s.stream_id} to={`/live/${s.stream_id}`} data-testid={`live-feed-${s.stream_id}`} className="card relative block">
            <div className="aspect-[4/5]"><img src={s.thumbnail_url} className="w-full h-full object-cover"/></div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent"/>
            <div className="absolute top-3 left-3"><LiveBadge/></div>
            <div className="absolute top-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded flex items-center gap-1">
              <Users size={12}/> {s.viewers}
            </div>
            <div className="absolute bottom-3 left-3 right-3">
              <div className="text-white font-display font-bold text-sm">{s.title}</div>
              <div className="text-xs text-[#A1A1AA]">@{s.host_name}</div>
            </div>
          </Link>
        ))}
        {streams.length === 0 && <div className="col-span-full text-center text-[#A1A1AA] py-16">No streams are live right now. Check back soon 👀</div>}
      </div>
    </div>
  );
}
